(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ecomativesby-collection-product"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ecomativesby-collection-product')) {
    customElements.define(
      'ecomativesby-collection-product',
      class extends HTMLElement {
        connectedCallback() {
          this.handle = (new URLSearchParams(window.location.search).get('ecomativesby') || '').trim().toLowerCase();
          if (!/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(this.handle)) return;

          this.section = this.closest('.shopify-section');
          if (!this.section) return;

          this.cardMarkup = new Map();
          this.fetchPromise = null;
          this.pending = false;
          this.observer = new MutationObserver(() => this.scheduleReconcile());
          this.observer.observe(this.section, { childList: true, subtree: true });
          this.reconcile();
        }

        disconnectedCallback() {
          this.observer?.disconnect();
        }

        scheduleReconcile() {
          if (this.pending) return;
          this.pending = true;
          window.requestAnimationFrame(() => {
            this.pending = false;
            this.reconcile();
          });
        }

        getContainer() {
          return this.section.querySelector('xo-filters-content .filters-content__grid, xo-filters-content .filters-content__list');
        }

        getLayout(container) {
          return container.classList.contains('filters-content__list') ? 'list' : 'grid';
        }

        handleFromLink(link) {
          try {
            const path = new URL(link.href, window.location.origin).pathname.split('/products/')[1];
            return decodeURIComponent(path?.split('/')[0] || '').toLowerCase();
          } catch (error) {
            return '';
          }
        }

        cardHandle(card) {
          if (card.dataset.ecomativesbyHandle) return card.dataset.ecomativesbyHandle.toLowerCase();

          const productLink = card.querySelector('a[href*="/products/"]');
          return productLink ? this.handleFromLink(productLink) : '';
        }

        matchingCards(container) {
          return Array.from(container.children).filter(
            (card) => card.matches('xo-product') && this.cardHandle(card) === this.handle
          );
        }

        restoreAddressParameter() {
          const url = new URL(window.location.href);
          if (url.searchParams.get('ecomativesby') === this.handle) return;

          url.searchParams.set('ecomativesby', this.handle);
          window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
        }

        reconcile() {
          const container = this.getContainer();
          if (!container) return;

          this.restoreAddressParameter();
          const layout = this.getLayout(container);
          const matches = this.matchingCards(container);

          if (matches.length) {
            const promoted = matches.find((card) => card.hasAttribute('data-ecomativesby-promoted')) || matches[0];
            promoted.dataset.ecomativesbyHandle = this.handle;
            promoted.setAttribute('data-ecomativesby-promoted', '');
            matches.forEach((card) => {
              if (card !== promoted) card.remove();
            });
            if (container.firstElementChild !== promoted) container.prepend(promoted);
            this.cardMarkup.set(layout, promoted.outerHTML);
            return;
          }

          const cachedMarkup = this.cardMarkup.get(layout);
          if (cachedMarkup) {
            this.insertCard(container, cachedMarkup);
            return;
          }

          this.fetchCards().then((cards) => {
            const currentContainer = this.getContainer();
            if (!cards || !currentContainer || this.matchingCards(currentContainer).length) return;

            const currentLayout = this.getLayout(currentContainer);
            const card = cards.get(currentLayout);
            if (!card) return;

            this.cardMarkup.set(currentLayout, card.outerHTML);
            this.insertCard(currentContainer, card.outerHTML);
          });
        }

        fetchCards() {
          if (this.fetchPromise) return this.fetchPromise;

          const root = window.Shopify?.routes?.root || '/';
          const url = `${root}products/${encodeURIComponent(this.handle)}?section_id=ecomativesby-product`;
          this.fetchPromise = fetch(url, { headers: { Accept: 'text/html' } })
            .then((response) => (response.ok ? response.text() : ''))
            .then((markup) => {
              const cards = new Map();
              if (!markup) return cards;

              const responseDocument = new DOMParser().parseFromString(markup, 'text/html');
              responseDocument.querySelectorAll('template[data-ecomativesby-layout]').forEach((template) => {
                const card = template.content.querySelector('xo-product');
                if (card && this.cardHandle(card) === this.handle) {
                  cards.set(template.dataset.ecomativesbyLayout, card);
                }
              });
              return cards;
            })
            .catch(() => new Map());

          return this.fetchPromise;
        }

        insertCard(container, markup) {
          const template = document.createElement('template');
          template.innerHTML = markup.trim();
          const card = template.content.querySelector('xo-product');
          if (!card || this.cardHandle(card) !== this.handle) return;

          card.dataset.ecomativesbyHandle = this.handle;
          card.setAttribute('data-ecomativesby-promoted', '');
          container.prepend(card);
          this.matchingCards(container).forEach((match) => {
            if (match !== card) match.remove();
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
